(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-sections-ck-shoppable-videos-1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('select-variants')) {
    customElements.define(
      'select-variants',
      class SelectVariants extends HTMLElement {
        abortController = undefined;

        constructor() {
          super();
          this.sectionId = this.getAttribute('data-section-id');
          this.productId = this.getAttribute('data-product-id');
          this.changeEvent = this.handleChangeEvent.bind(this);
        }

        connectedCallback() {
          this.addEventListener('change', this.changeEvent);
        }

        handleChangeEvent(e) {
          this.updateSelectionMetadata(e);
          this.renderProductInfo(this.selectedOptionValues);
        }

        updateVariantData(requestUrl) {
          this.abortController?.abort();
          this.abortController = new AbortController();

          const selectedPlan = this.querySelector('input[name="purchase_option"]:checked')?.value;
          console.log(this.querySelector('input[name="purchase_option"]:checked'));

          fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              console.log(html);

              const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
                const source = html.getElementById(`${id}-${this.sectionId}-${this.productId}`);
                const destination = document.querySelector(`#${id}-${this.sectionId}-${this.productId}`);
                if (source && destination) {
                  destination.innerHTML = source.innerHTML;
                }
              };

              updateSourceFromDestination('ProductPrice');
              updateSourceFromDestination('SelectPlans');
              updateSourceFromDestination('SelectVariants');

              if (selectedPlan !== undefined) {
                const radio = this.querySelector(`input[name="purchase_option"][value="${selectedPlan}"]`);

                if (radio) {
                  radio.checked = true;
                }
                this.productForm.querySelector('[name="selling_plan"]').value = selectedPlan;
              }
            })
            .catch((error) => {
              if (error.name === 'AbortError') {
                console.log('Fetch aborted by user');
              } else {
                console.error(error);
              }
            })
            .finally(() => {
              const variant = this.parseJsonScript(this.getSelectedVariant);
              console.log(variant);
              console.log(variant.selling_plan_allocations);

              this.productForm.querySelector('input[name="id"]').value = variant.id;
              this.productFormSubmit.removeAttribute('disabled');
            });
        }

        parseJsonScript(variantSelector) {
          try {
            return JSON.parse(variantSelector?.textContent);
          } catch {
            return null;
          }
        }

        renderProductInfo(selectedOptionValues) {
          const params = [];
          const url = this.getAttribute('data-product-url');
          params.push(`section_id=${this.sectionId}`);
          if (selectedOptionValues.length) {
            params.push(`option_values=${selectedOptionValues.join(',')}`);
          }
          const requestUrl = `${url}?${params.join('&')}`;
          this.productFormSubmit.setAttribute('disabled', '');
          this.updateVariantData(requestUrl);
        }

        updateSelectionMetadata({ target }) {
          const { value, tagName } = target;

          if (tagName === 'SELECT' && target.selectedOptions.length) {
            Array.from(target.options)
              .find((option) => option.getAttribute('selected'))
              ?.removeAttribute('selected');
            target.selectedOptions[0].setAttribute('selected', 'selected');
          }

          if (tagName === 'INPUT' && target.type === 'radio') {
            this.productForm.querySelector('[name="selling_plan"]').value = target.value;
          }
        }

        get productForm() {
          return this.closest('form');
        }

        get productFormSubmit() {
          return this.productForm?.querySelector('button[type="submit"]');
        }

        get selects() {
          return this.querySelectorAll('select');
        }

        get selectedOptionValues() {
          return Array.from(this.querySelectorAll('select option[selected]')).map(
            ({ dataset }) => dataset.optionValueId
          );
        }

        get getSelectedVariant() {
          return this.querySelector('script[data-selected-variant]');
        }
      }
    );
  }

  if (!customElements.get('ck-shoppable-section')) {
    customElements.define(
      'ck-shoppable-section',
      class CKShoppable extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.mainSlider = this.querySelector('[id^="Main-Slider-"]');
          this.popupSlider = this.querySelector('[id^="Popup-Slider-"]');
          this.popupProductImageSlider = this.querySelector('[id^="Shoppable-Product-Slider-"]');
          this.mainNext = this.querySelector('[id^="Main-next-"]');
          this.MainPrev = this.querySelector('[id^="Main-prev-"]');
          this.next = this.querySelector('[id^="Next-"]');
          this.prev = this.querySelector('[id^="Prev-"]');
          if (!this.mainSlider || !this.popupSlider) return;

          this.sliderInit();
          this.syncPopupVideo();
          this.hoverMainSliderVideoPlay();
          this.popupMiniScreen();
          this.closePopupSlider();
          this.popupSliderOpen();
          this.mutePopupvideo();
          this.popupSliderVideoPause();
          this.shoppableDrawer();
        }

        sliderInit() {
          this.mainSwiper = new Swiper(this.mainSlider, {
            slidesPerView: 1.5,
            spaceBetween: 16,
            navigation: {
              nextEl: this.mainNext,
              prevEl: this.MainPrev,
            },
            breakpoints: {
              480: {
                slidesPerView: 2.5,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 3.5,
                spaceBetween: 16,
              },
              980: {
                slidesPerView: 4.1,
                spaceBetween: 16,
              },
              1440: {
                slidesPerView: 5.2,
                spaceBetween: 16,
              },
            },
          });

          this.productImageSwiper = new Swiper(this.popupProductImageSlider, {
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
              nextEl: this.next,
              prevEl: this.prev,
            },
          });

          this.popupSwiper = new Swiper(this.popupSlider, {
            slidesPerView: 1.1,
            spaceBetween: 16,
            direction: 'vertical',
            loop: false,
            mousewheel: {
              invert: true,
            },
          });
          this.popupVideos = this.popupSlider.querySelectorAll('video');
        }

        hoverMainSliderVideoPlay() {
          this.mainSlidervideos = this.mainSlider.querySelectorAll('video');

          // const pauseAll = (except = null) => {
          //   this.mainSlidervideos.forEach((video) => {
          //     if (video !== except) {
          //       video.pause();
          //       video.currentTime = video.currentTime;
          //     }
          //   });
          // };

          const pauseAll = (except = null) => {
            this.mainSlidervideos.forEach((video) => {
              if (video !== except && !video.paused) {
                video.pause();
                video.currentTime = 0; // only reset ones that were actually playing
              }
            });
          };

          this.mainSlidervideos.forEach((video) => {
            video.addEventListener('mouseenter', () => {
              pauseAll(video);
              video.closest('.video-card').classList.add('pause-button-hide');
              const playPromise = video.play();
              if (playPromise !== undefined) {
                playPromise.catch((err) => {
                  console.log('Play error:', err);
                });
              }
            });

            video.addEventListener('mouseleave', () => {
              video.pause();
              video.closest('.video-card').classList.remove('pause-button-hide');
            });

            video.addEventListener('play', () => {
              pauseAll(video);
            });
          });
        }

        popupMiniScreen() {
          this.miniScreenButton = this.popupSlider.querySelectorAll('.mini-button');
          this.miniScreenButton.forEach((button) => {
            button.addEventListener('click', function () {
              button.closest('.ck-shoppable-popup-slider').classList.toggle('mini-video');
            });
          });
        }

        closePopupSlider() {
          this.closeButton = this.popupSlider.querySelectorAll('.popup-close');

          this.closeButton.forEach((button) => {
            button.addEventListener('click', () => {
              button.closest('.ck-shoppable-popup-slider').classList.add('hidden');
              this.drawer.classList.remove('drawer-open');
              this.stopAllPopupVideos();
            });
          });
        }

        popupSliderOpen() {
          this.clickablevideo = this.mainSlider.querySelectorAll('video');

          this.clickablevideo.forEach((clickVideo, index) => {
            clickVideo.addEventListener('click', () => {
              const popup = this.querySelector('.ck-shoppable-popup-slider');
              if (!popup) return;
              popup.classList.remove('hidden');

              if (this.popupSwiper) {
                this.popupSwiper.slideTo(index, 0);

                // setTimeout(() => {
                //   const activeSlide = this.popupSwiper.slides[this.popupSwiper.activeIndex];

                //   const video = activeSlide?.querySelector('video');

                //   if (video) {
                //     this.stopAllPopupVideos();
                //     video.play().catch(() => {});
                //   }
                // }, 100);
                setTimeout(() => {
  const activeSlide = this.popupSwiper.slides[this.popupSwiper.activeIndex];

  const video = activeSlide?.querySelector('video');

  if (video) {
    this.stopAllPopupVideos();

    const slideWrapper = video.closest('.swiper-slide-wrapper');

    // Remove the class before playing
    slideWrapper?.classList.remove('video-pause-active');

    // Add the class whenever the video is paused
    video.addEventListener('pause', () => {
      slideWrapper?.classList.add('video-pause-active');
    });

    // Remove the class whenever the video starts playing
    video.addEventListener('play', () => {
      slideWrapper?.classList.remove('video-pause-active');
    });

    video.play().catch(() => {});
  }
}, 100);
              }
            });
          });
        }

        stopAllPopupVideos() {
          const videos = this.popupSlider.querySelectorAll('video');

          videos.forEach((v) => {
            v.pause();
            v.currentTime = v.currentTime;
          });
        }

        syncPopupVideo() {
          if (!this.popupSwiper) return;

          const playActive = () => {
            const activeSlide = this.popupSwiper.slides[this.popupSwiper.activeIndex];
            if (!activeSlide) return;

            const video = activeSlide.querySelector('video');
            if (!video) return;

            this.stopAllPopupVideos();

            setTimeout(() => {
              requestAnimationFrame(() => {
                const playPromise = video.play();
                if (playPromise) {
                  playPromise.catch(() => {});
                }
              });
            }, 80);
          };

          this.popupSwiper.on('init', playActive);
          this.popupSwiper.on('slideChangeTransitionEnd', playActive);
        }

        mutePopupvideo() {
          const muteButtons = this.popupSlider.querySelectorAll('.mute-button');

          muteButtons.forEach((button) => {
            button.addEventListener('click', () => {
              const slide = button.closest('.swiper-slide-wrapper');
              const video = slide?.querySelector('video');

              if (!video) return;

              video.muted = !video.muted;

              button.classList.toggle('is-muted', video.muted);
            });
          });
        }

        popupSliderVideoPause() {
          const popupVideos = this.popupSlider.querySelectorAll('video');

          popupVideos.forEach((video) => {
            video.addEventListener('click', () => {
              if (video.paused) {
                video.closest('.swiper-slide-wrapper').classList.remove('video-pause-active');
                video.play().catch(() => {});
              } else {
                video.closest('.swiper-slide-wrapper').classList.add('video-pause-active');
                video.pause();
              }
            });
          });
        }

        // popupSliderVideoPause() {
        //   const popupVideos = this.popupSlider.querySelectorAll('video');

        //   const togglePlay = (video) => {
        //     const wrapper = video.closest('.swiper-slide-wrapper');
        //     if (!wrapper) return;

        //     if (video.paused) {
        //       wrapper.classList.remove('video-pause-active');
        //       video.play().catch(() => {});
        //     } else {
        //       wrapper.classList.add('video-pause-active');
        //       video.pause();
        //     }
        //   };

        //   popupVideos.forEach((video) => {
        //     video.addEventListener('click', () => togglePlay(video));
        //   });

        //   // Fix: the pause button overlays the video and intercepts clicks,
        //   // but previously had no handler of its own.
        //   const pauseButtons = this.popupSlider.querySelectorAll('.pause-button');
        //   pauseButtons.forEach((button) => {
        //     button.addEventListener('click', (e) => {
        //       e.stopPropagation();
        //       const video = button.closest('.swiper-slide-wrapper')?.querySelector('video');
        //       if (video) togglePlay(video);
        //     });
        //   });
        // }

        shoppableDrawer() {
          this.products = this.popupSlider.querySelectorAll('.video-card-product');
          this.drawerProducts = this.querySelectorAll('.ck-shoppable-product-item');
          this.drawer = this.querySelector('.ck-shoppable-product-drawer');
          this.drawerClose = this.querySelector('.quick-add-close');

          this.products.forEach((thumbProduct) => {
            thumbProduct.addEventListener('click', () => {
              const productId = thumbProduct.dataset.productId;

              this.drawer.classList.add('drawer-open');

              this.drawerProducts.forEach((item) => {
                const itemId = item.dataset.productId;

                if (itemId === productId) {
                  item.classList.remove('hidden');
                } else {
                  item.classList.add('hidden');
                }
              });
            });
          });

          this.drawerClose.addEventListener('click', () => {
            this.drawer.classList.remove('drawer-open');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
